// extracted by mini-css-extract-plugin
module.exports = {"iconsContainer":"styles_iconsContainer_2j6IqMXd1LbSB0LSI0baSy","button":"styles_button_3-wTLiArDeE7FgGl0mAnDg","clear":"styles_clear_2_oD_Dxz-HAJaXnUCrVaDF"};